<script setup lang="ts">
import { setup } from './baseMenuSearch.setup';

const { t, searchValue, isMac, onMouseDown } = setup();
</script>

<template>
  <div
    class="base-menu-search"
    @mousedown="onMouseDown"
  >
    <ev-icon
      class="base-menu-search__icon"
      icon="ev-icon-search2"
      size="large"
    />
    <ev-text-field
      v-model="searchValue"
      class="base-menu-search__input"
      type="text"
      :placeholder="t('WORD.SEARCH')"
      tabindex="-1"
    />
    <div class="base-menu-search__shortcut">
      <span class="base-menu-search__shortcut-key">{{ isMac ? '⌘' : 'Ctrl' }}</span>
      <span class="base-menu-search__shortcut-plus">+</span>
      <span class="base-menu-search__shortcut-key">K</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.base-menu-search {
  display: flex;
  position: relative;
  gap: 8px;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 8px;
  overflow: hidden;
  border: 1px solid rgb(var(--color-gray-00-00-rgb), 0.2);
  border-radius: 4px;
  background-color: rgb(var(--color-gray-00-00-rgb), 0.08);

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border-radius: 4px;
    content: '';
  }

  &:hover {
    cursor: pointer;
    border-color: rgb(var(--color-gray-00-00-rgb), 0.4);
    box-shadow: 0 0 0 3px rgb(var(--color-gray-00-00-rgb), 0.12);
  }

  &:focus-within {
    border-color: var(--color-blue-05-05);
    box-shadow: 0 0 0 3px rgb(var(--color-gray-00-00-rgb), 0.12);
  }

  &:active {
    cursor: pointer;
    border-color: rgb(var(--color-gray-00-00-rgb), 0.6);
    box-shadow: 0 0 0 3px rgb(var(--color-gray-00-00-rgb), 0.12);
  }

  &__icon {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    font-size: var(--gnb-menu-icon-size);
    color: var(--color-gray-03-07);
  }

  &__input {
    position: relative;
    z-index: 1;
    flex: 1;
    min-width: 0;
    height: 100%;

    :deep(.ev-text-field-wrapper) {
      height: 100%;
    }

    :deep(.ev-input) {
      height: 100% !important;
      padding: 0 !important;
      opacity: 0.9;
      pointer-events: none;
      border: none !important;
      outline: none;
      background-color: transparent !important;
      font-size: 13px !important;
    }

    :deep(.ev-input::placeholder) {
      color: #ffffff;
    }
  }

  &__shortcut {
    display: flex;
    z-index: 1;
    flex-shrink: 0;
    gap: 4px;
    align-items: center;
    pointer-events: none;
    user-select: none;
    font-size: 11px;
    font-weight: 500;
  }

  &__shortcut-key {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border: 1px solid rgb(var(--color-gray-00-00-rgb), 0.16);
    border-radius: 3px;
    color: var(--gnb-text-sub-color);

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.05;
      pointer-events: none;
      border-radius: 3px;
      background-color: var(--color-gray-03-07);
      content: '';
    }
  }

  &__shortcut-plus {
    color: var(--gnb-text-sub-color);
  }

  // 축소형 GNB일 때는 검색 아이콘만 노출 (입력창/단축키 텍스트 숨김)
  .base-menu:not(.expanded) & {
    flex-shrink: 0;
    gap: 0;
    width: var(--gnb-menu-item-content-width);
    min-width: var(--gnb-menu-item-content-width);
    max-width: var(--gnb-menu-item-content-width);
    height: var(--gnb-menu-item-height);
    padding: 8px;

    &__input,
    &__shortcut {
      display: none;
    }
  }
}
</style>
